export const direction = [ //朝向（房源维护、房源租赁）
    { title: '东', value: '东' },
    { title: '西', value: '西' },
    { title: '南', value: '南' },
    { title: '北', value: '北' },
    { title: '东南', value: '东南' },
    { title: '东北', value: '东北' },
    { title: '西南', value: '西南' },
    { title: '西北', value: '西北' },
    { title: '东西', value: '东西' },
    { title: '南北', value: '南北' },
    { title: '其他', value: '其他' },
];

export const gender = [ //性别
    { title: '男', value: 1 },
    { title: '女', value: 2 },
];

export const commonIsMap = [
    { title: '是', value:1 },
    { title: '否', value:2 },
]

//同步状态声明
export const syncStatusIsMap = [
    { title: '同步成功', value:1 },
    { title: '未同步', value:2 },
]

//报修状态声明
export const repairReportStatusIsMap = [
    { title: '待处理', value:1 },
    { title: '派单中', value:2 },
    { title: '维修中', value:3 },
    { title: '已完成', value:4 }
]

export const repairRadioValueIsMap = [
    { title: '报修', value: '报修' },
    { title: '清洗服务', value: '清洗服务' }

]



//同步状态声明
export const checkStatusIsMap = [
    { title: '已核对', value:1 },
    { title: '未核对', value:2 },
]

export const acceptStatusIsMap = [
    { title: '已更新验收日期', value:1 },
    { title: '未更新验收日期', value:2 },
]

export const deviceBillStatusIsMap = [
    { title: '已租', value:1 },
    { title: '空置', value:2 },
]

export const downloadTagsMap = [
    { title: '已下载', value:1 },
    { title: '未下载', value:2 },
]

//资金渠道
export const capitalChannelIsMap = [
    { title: '建行', value:1 },
    { title: '宝生', value:2 },
]

//同步接口类型
export const syncApiTypeIsMap = [
    { title: '图片上传', value:1 },
    { title: '获取行政区域', value:2 },
    { title: '小区对齐', value:3 },
    { title: '创建门店', value:4 },
    { title: '修改门店', value:5 },
    { title: '创建户型', value:6 },
    { title: '修改户型', value:7 },
    { title: '删除户型', value:8 },
    { title: '创建房间', value:9 },
    { title: '修改房间', value:10 },
    { title: '删除房间', value:11 },
    { title: '合同关闭', value:12 },
    { title: '合同签约', value:13 },
    { title: '账单修改', value:14 },
    { title: '账单废弃', value:15 },
    { title: '账单新增', value:16 },
    { title: '账单查询', value:17 },
    { title: '房源上下架', value:18 },
]
//同步报警状态
export const warningStatusIsMap = [
    { title: '未处理', value:1 , color: 'green' },
    { title: '已处理', value:2 , color: 'red'},
]

//报警业务名称
export const serviceNameIsMap = [
    { title: '户型', value:'roomType' },
    { title: '门店', value:'ccbProject'},
    { title: '小区/楼栋', value:'building'},
    { title: '房源', value:'house'},
    { title: '合同', value:'rentContract'},
]



export const expireDate = [ //应付日
    { title: '距离应付日7天内', value: 1 },
    { title: '距离应付日3天内', value: 2 },
    { title: '距离应付日1天', value: 3 },
    { title: '应付日当天', value: 4 },
    { title: '已过应付日', value: 5 },
];

export const credentialType = [ //证件类型
    { title: '国内身份证', value: 1 },
    { title: '护照', value: 2 },
    { title: '港澳居民来往内地通行证', value: 3 },
    { title: '台湾居民来往大陆通行证', value: 4 }
];

export const contractType = [ //合同类型（租客合同）
    { title: '电子', value: 1 },
    { title: '纸质', value: 2 }
];

// 费用类别
export const dicFeeType = [
    { title: '租金', value: 1 },
    { title: '押金', value: 2 },
    { title: '杂费', value: 3 },
    { title: '结算', value: 4 },
    { title: '其他', value: 5 },
]

// 小区楼栋状态
export const dicBuildingStatus = [
    { title: '正常', value: 1, color: 'green' },
    { title: '停用', value: 2, color: 'red' },
]
export  const dicClarifyStatus =[
    { title: '是', value: 1, color: 'green' },
    { title: '否', value: 2, color: 'red' },
]
export  const  dicRecvCertType =[
    { title: '中华人民共和国居民身份证', value: '01'},
    { title: '军人证件', value: '02'},
    { title: '港澳台通行证', value: '03'},
    { title: '华侨身份证', value: '04'},
    { title: '外籍护照', value: '05'},
    { title: '统一社会信用代码', value: '06'},
]

// 合同来源
export const dicContractSource = [
    { title: '新签', value: 1 },
    { title: '续租', value: 2 },
    { title: '换房', value: 3 },
    { title: '补录', value: 4 },
]

// 合同审批状态
export const mapRentContractApprovalStatus = [
    { title: '待审批', value: 1 },
    { title: '已通过', value: 2 },
    { title: '不通过', value: 3 },
]

// 合同审批状态
export const mapRentContractApprovalType = [
    { title: '系统审批', value: 1 },
    { title: '人工审批', value: 2 },
]

// 租客状态
export const dicCustomerStatus = [
    { title: '正常', value: 1, color: 'green' },
    { title: '停用', value: 2, color: 'red' },
]


export const dicDiscountCouponStatus = [
    { title: '启用', value: 1, color: 'green' },
    { title: '禁用', value: 2, color: 'red' },
]

export const dicDiscountCouponLogStatus = [
    { title: '未使用', value: 1, color: 'green' },
    { title: '锁定中', value: 2, color: 'blue' },
    { title: '已核销', value: 3, color: 'orange' },
]



// 租客来源类别
export const dicCustomerSourceType = [
    { title: '商户签约', value: 1 },
    { title: '微信注册', value: 2 },
]

// 平台部门状态
export const dicDepartmentStatus = [
    { title: '正常', value: 1, color: 'green' },
    { title: '停用', value: 2, color: 'red' },
]

// 平台人员状态
export const dicEmployeeStatus = [
    { title: '正常', value: 1, color: 'green' },
    { title: '停用', value: 2, color: 'red' },
]

// 房源状态
export const dicHouseStatus = [
    { title: '待租', value: 1, color: 'green' },
    { title: '已租', value: 2, color: 'blue' },
    { title: '装修', value: 3, color: 'orange' },
    { title: '停租', value: 4, color: 'red' },
]


export const dicRentGrowth = [
    { title: '大于参考租金', value: 1 },
    { title: '小于参考租金', value: 2 },
    { title: '等于参考租金', value: 3 },
]



// 商户状态
export const dicMerchantStatus = [
    { title: '正常', value: 1, color: 'green' },
    { title: '停用', value: 2, color: 'red' },
]

// 商户部门状态
export const dicMerchantDepartmentStatus = [
    { title: '正常', value: 1, color: 'green' },
    { title: '停用', value: 2, color: 'red' },
]

// 商户人员状态
export const dicMerchantUserStatus = [
    { title: '正常', value: 1, color: 'green' },
    { title: '停用', value: 2, color: 'red' },
]

// 支付渠道
export const dicPayChannel = [
    { title: '微信', value: 1 },
    // { title: '银盛', value: 2 },
    // { title: '支付宝', value: 3 },
    { title: '银行', value: 4 },
    { title: '建设银行', value: 6 },
    { title: '从其他账单转入', value: 5 },
]

// 支付方式
export const dicPayType = [
    { title: '转帐支付', value: 1 },
    // { title: '协议支付', value: 2 },
    { title: '微信公众号支付', value: 3 },
    { title: '从其他账单转入', value: 5 },
    { title: '建融小程序支付', value: 6 },
    { title: '数字人民币支付', value: 7 },
    { title: '惠市宝支付', value: 8 },

]

export const hsbPayChannelStatus =[
    { title: '启用', value: 1 },
    { title: '禁用', value: 2 },
]


export const hsbPayClrgRuleStatus =[
    { title: '启用', value: 1 },
    { title: '禁用', value: 2 },
]



// 项目状态
export const dicProjectStatus = [
    { title: '正常', value: 1, color: 'green' },
    { title: '停用', value: 2, color: 'red' },
]


// 费用类型
export const dicClrgRuleType = [
    { title: '业主租金', value: 1, color: 'green' },
    { title: '平台云贷费用', value: 2, color: 'red' },
    { title: '平台服务费用', value: 3, color: 'red' },
    { title: '结余费用', value: 4, color: 'red' },
    { title: '其他费用', value: 5, color: 'red' },
]

// 执行顺序
export const dicExecutionSequenceType = [
    { title: '1', value: 1 },
    { title: '2', value: 2 },
    { title: '3', value: 3 },
    { title: '4', value: 4 },
    { title: '5', value: 5 },
    { title: '6', value: 6 },
    { title: '7', value: 7 },
    { title: '8', value: 8 },
    { title: '9', value: 9 },
    { title: '10', value: 10 },
    { title: '11', value: 11 },
    { title: '12', value: 12 },
    { title: '13', value: 13 },
    { title: '14', value: 14 },
    { title: '15', value: 15 },
    { title: '16', value: 16 },
    { title: '17', value: 17 },
    { title: '18', value: 18 },
    { title: '19', value: 19 },
    { title: '20', value: 20 },

]
//executionCycle
// 执行周期
export const dicExecutionCycle = [
    { title: "1期", value: 1 },
    { title: "2期", value: 2 },
    { title: "3期", value: 3 },
    { title: "4期", value: 4 },
    { title: "5期", value: 5 },
    { title: "6期", value: 6 },
    { title: "7期", value: 7 },
    { title: "8期", value: 8 },
    { title: "9期", value: 9 },
    { title: "10期", value: 10 },
    { title: "11期", value: 11 },
    { title: "12期", value: 12 },
    { title: "13期", value: 13 },
    { title: "14期", value: 14 },
    { title: "15期", value: 15 },
    { title: "16期", value: 16 },
    { title: "17期", value: 17 },
    { title: "18期", value: 18 },
    { title: "19期", value: 19 },
    { title: "20期", value: 20 },
    { title: "21期", value: 21 },
    { title: "22期", value: 22 },
    { title: "23期", value: 23 },
    { title: "24期", value: 24 },
    { title: "25期", value: 25 },
    { title: "26期", value: 26 },
    { title: "27期", value: 27 },
    { title: "28期", value: 28 },
    { title: "29期", value: 29 },
    { title: "30期", value: 30 },
    { title: "31期", value: 31 },
    { title: "32期", value: 32 },
    { title: "33期", value: 33 },
    { title: "34期", value: 34 },
    { title: "35期", value: 35 },
    { title: "36期", value: 36 },
    { title: "37期", value: 37 },
    { title: "38期", value: 38 },
    { title: "39期", value: 39 },
    { title: "40期", value: 40 },
    { title: "41期", value: 41 },
    { title: "42期", value: 42 },
    { title: "43期", value: 43 },
    { title: "44期", value: 44 },
    { title: "45期", value: 45 },
    { title: "46期", value: 46 },
    { title: "47期", value: 47 },
    { title: "48期", value: 48 },
    { title: "49期", value: 49 },
    { title: "50期", value: 50 },
    { title: "51期", value: 51 },
    { title: "52期", value: 52 },
    { title: "53期", value: 53 },
    { title: "54期", value: 54 },
    { title: "55期", value: 55 },
    { title: "56期", value: 56 }
]
// 租赁合同.零散租期类别
export const dicRentContractFirstLastRentType = [
    { title: '不设置', value: 1 },
    { title: '零散租期前后置', value: 2 },
]

// 租赁合同.签约状态
export const dicRentContractSignStatus = [
    { title: '租客未签商户未签', value: 1 },
    { title: '租客已签商户未签', value: 3 },
    { title: '已签', value: 2 },
]

// 租赁合同.租赁状态(未签时给空值)
export const dicRentContractRentStatus = [
    { title: '在租', value: 1, color: 'green' },
    { title: '已退租', value: 2, color: 'orange' },
    // { title: '已删除', value: 3, color: 'red' },
]

// 租赁合同.结算状态(未退租时给空值)
export const dicRentContractSettlementStatus = [
    { title: '已结清', value: 1 },
    { title: '待收款', value: 2 },
    { title: '待退款', value: 3 },
]

// 角色状态
export const dicRoleStatus = [
    { title: '正常', value: 1, color: 'green' },
    { title: '停用', value: 2, color: 'red' },
]

// 租客类型
export const customerType = [
    { title: '企业', value: 1, color: 'blue' },
    { title: '个人', value: 2, color: 'blue' },
]

// 商户类型
export const dicMerchantType = [
    { title: '企业', value: 1 },
    { title: '个人', value: 2 },
]

// 交易流水状态
export const dicTradeRecordStatus = [
    { title: '待审核', value: 1 },
    { title: '已到帐', value: 2 },
    { title: '未到帐', value: 3 },
]

// 民族
export const nation = [
    { title: "汉", value: "汉" },
    { title: "满", value: "满" },
    { title: "蒙古", value: "蒙古" },
    { title: "回", value: "回" },
    { title: "藏", value: "藏" },
    { title: "维吾尔", value: "维吾尔" },
    { title: "苗", value: "苗" },
    { title: "彝", value: "彝" },
    { title: "壮", value: "壮" },
    { title: "布依", value: "布依" },
    { title: "侗", value: "侗" },
    { title: "瑶", value: "瑶" },
    { title: "白", value: "白" },
    { title: "土家", value: "土家" },
    { title: "哈尼", value: "哈尼" },
    { title: "哈萨克", value: "哈萨克" },
    { title: "傣", value: "傣" },
    { title: "黎", value: "黎" },
    { title: "傈僳", value: "傈僳" },
    { title: "佤", value: "佤" },
    { title: "畲", value: "畲" },
    { title: "高山", value: "高山" },
    { title: "拉祜", value: "拉祜" },
    { title: "水", value: "水" },
    { title: "东乡", value: "东乡" },
    { title: "纳西", value: "纳西" },
    { title: "景颇", value: "景颇" },
    { title: "柯尔克孜", value: "柯尔克孜" },
    { title: "土", value: "土" },
    { title: "达斡尔", value: "达斡尔" },
    { title: "仫佬", value: "仫佬" },
    { title: "羌", value: "羌" },
    { title: "布朗", value: "布朗" },
    { title: "撒拉", value: "撒拉" },
    { title: "毛南", value: "毛南" },
    { title: "仡佬", value: "仡佬" },
    { title: "锡伯", value: "锡伯" },
    { title: "阿昌", value: "阿昌" },
    { title: "普米", value: "普米" },
    { title: "朝鲜", value: "朝鲜" },
    { title: "塔吉克", value: "塔吉克" },
    { title: "怒", value: "怒" },
    { title: "乌孜别克", value: "乌孜别克" },
    { title: "俄罗斯", value: "俄罗斯" },
    { title: "鄂温克", value: "鄂温克" },
    { title: "德昂", value: "德昂" },
    { title: "保安", value: "保安" },
    { title: "裕固", value: "裕固" },
    { title: "京", value: "京" },
    { title: "塔塔尔", value: "塔塔尔" },
    { title: "独龙", value: "独龙" },
    { title: "鄂伦春", value: "鄂伦春" },
    { title: "赫哲", value: "赫哲" },
    { title: "门巴", value: "门巴" },
    { title: "珞巴", value: "珞巴" },
    { title: "基诺", value: "基诺" }
]

export const payCycleType =[
    { title: "本月", value: 1 },
    { title: "次月", value: 2 },
]

export const wftSplitAccount =[
    { title: "分账", value: 1 },
    { title: "不分账", value: 2 },
]

export const wftSignType =[
    { title: "MD5", value: "MD5" },
    { title: "RSA_1_256", value: "RSA_1_256" },
]

// 租金付款日1-28
export const payCycleDate = [
    { title: "1日", value: 1 },
    { title: "2日", value: 2 },
    { title: "3日", value: 3 },
    { title: "4日", value: 4 },
    { title: "5日", value: 5 },
    { title: "6日", value: 6 },
    { title: "7日", value: 7 },
    { title: "8日", value: 8 },
    { title: "9日", value: 9 },
    { title: "10日", value: 10 },
    { title: "11日", value: 11 },
    { title: "12日", value: 12 },
    { title: "13日", value: 13 },
    { title: "14日", value: 14 },
    { title: "15日", value: 15 },
    { title: "16日", value: 16 },
    { title: "17日", value: 17 },
    { title: "18日", value: 18 },
    { title: "19日", value: 19 },
    { title: "20日", value: 20 },
    { title: "21日", value: 21 },
    { title: "22日", value: 22 },
    { title: "23日", value: 23 },
    { title: "24日", value: 24 },
    { title: "25日", value: 25 },
    { title: "26日", value: 26 },
    { title: "27日", value: 27 },
    { title: "28日", value: 28 },
    { title: "29日", value: 29 },
    { title: "30日", value: 30 },
    { title: "31日", value: 31 },
]
export const totalNumberPeriods = [
    { title: "1期", value: 1 },
    { title: "2期", value: 2 },
    { title: "3期", value: 3 },
    { title: "4期", value: 4 },
    { title: "5期", value: 5 },
    { title: "6期", value: 6 },
    { title: "7期", value: 7 },
    { title: "8期", value: 8 },
    { title: "9期", value: 9 },
    { title: "10期", value: 10 },
    { title: "11期", value: 11 },
    { title: "12期", value: 12 },
    { title: "13期", value: 13 },
    { title: "14期", value: 14 },
    { title: "15期", value: 15 },
    { title: "16期", value: 16 },
    { title: "17期", value: 17 },
    { title: "18期", value: 18 },
    { title: "19期", value: 19 },
    { title: "20期", value: 20 },
    { title: "21期", value: 21 },
    { title: "22期", value: 22 },
    { title: "23期", value: 23 },
    { title: "24期", value: 24 },
    { title: "25期", value: 25 },
    { title: "26期", value: 26 },
    { title: "27期", value: 27 },
    { title: "28期", value: 28 },
    { title: "29期", value: 29 },
    { title: "30期", value: 30 },
    { title: "31期", value: 31 },
    { title: "32期", value: 32 },
    { title: "33期", value: 33 },
    { title: "34期", value: 34 },
    { title: "35期", value: 35 },
    { title: "36期", value: 36 },
    { title: "37期", value: 37 },
    { title: "38期", value: 38 },
    { title: "39期", value: 39 },
    { title: "40期", value: 40 },
    { title: "41期", value: 41 },
    { title: "42期", value: 42 },
    { title: "43期", value: 43 },
    { title: "44期", value: 44 },
    { title: "45期", value: 45 },
    { title: "46期", value: 46 },
    { title: "47期", value: 47 },
    { title: "48期", value: 48 },
    { title: "49期", value: 49 },
    { title: "50期", value: 50 },
    { title: "51期", value: 51 },
    { title: "52期", value: 52 },
    { title: "53期", value: 53 },
    { title: "54期", value: 54 },
    { title: "55期", value: 55 },
    { title: "56期", value: 56 }
]


// 租金付款日1-28
export const paymentDate = [
    { title: "每月1日", value: 1 },
    { title: "每月2日", value: 2 },
    { title: "每月3日", value: 3 },
    { title: "每月4日", value: 4 },
    { title: "每月5日", value: 5 },
    { title: "每月6日", value: 6 },
    { title: "每月7日", value: 7 },
    { title: "每月8日", value: 8 },
    { title: "每月9日", value: 9 },
    { title: "每月10日", value: 10 },
    { title: "每月11日", value: 11 },
    { title: "每月12日", value: 12 },
    { title: "每月13日", value: 13 },
    { title: "每月14日", value: 14 },
    { title: "每月15日", value: 15 },
    { title: "每月16日", value: 16 },
    { title: "每月17日", value: 17 },
    { title: "每月18日", value: 18 },
    { title: "每月19日", value: 19 },
    { title: "每月20日", value: 20 },
    { title: "每月21日", value: 21 },
    { title: "每月22日", value: 22 },
    { title: "每月23日", value: 23 },
    { title: "每月24日", value: 24 },
    { title: "每月25日", value: 25 },
    { title: "每月26日", value: 26 },
    { title: "每月27日", value: 27 },
    { title: "每月28日", value: 28 }
]

// 认证状态
export const authenticationStatus = [
    { title: '系统认证', value: 1 },
    { title: '人工认证', value: 2 },
]

// 退租类型
export const checkOutType = [
    { title: '到期退租', value: 1 },
    { title: '违约退租', value: 2 },
    { title: '转租退租', value: 3 },
    { title: '换房退租', value: 4 },
    { title: '协议退租', value: 5 }
]

// 退租类型
export const checkOutState = [
    { title: '未完成', value: 1 },
    { title: '已完成', value: 2 },
]

// 退款方式
export const backMoneyType = [
    { title: '微信', value: 1 },
    { title: '支付宝', value: 2 },
    { title: '银行', value: 3 },
    { title: '现金', value: 4 },
    { title: '转入其他合同', value: 5 },
]

// 收款方式
export const receivablesMoneyType = [
    { title: '账单收款', value: 1 },
]

//收款账单状态
export const ReceivablesType = [
    { title: '待审核', value: 1 },
    { title: '未结清', value: 2 },
    { title: '已结清', value: 3 },
    { title: '不收(已退租)', value: 4 }
]

//收款明细交易状态
export const businessState = [
    { title: '待审核', value: 1 },
    { title: '未结清', value: 2 },
    { title: '已结清', value: 3 },
    { title: '不收(已退租)', value: 4 },
]

//项目转账审核状态
export const projectTransfer = [
    { title: '待审核', value: 1 ,color:'gray'},
    { title: '已到帐', value: 2 ,color:'green'},
    { title: '未到帐', value: 3 ,color:'red'},
]

//签约信息--签约类型
export const contractSource = [
    { title: '新签', value: 1 },
    { title: '续签', value: 2 },
    { title: '换房', value: 3 },
    { title: '补录', value: 4 },
]

//短信发送明细--短信发送状态
export const shortMsgStatus = [
    { title: '成功', value: 1 },
    { title: '失败', value: 2 },
]
export const jrApiNameStatus = [
    //图片上传(1,"图片上传"),
    //     获取行政区域(2,"获取行政区域"),
    //     小区对齐(3,"小区对齐"),
    //     创建门店(4,"创建门店"),
    //     修改门店(5,"修改门店"),
    //     创建户型(6,"创建户型"),
    //     修改户型(7,"修改户型"),
    //     删除户型(8,"删除户型"),
    //     创建房间(9,"创建房间"),
    //     修改房间(10,"修改房间"),
    //     删除房间(11,"删除房间"),
    //     合同关闭(12,"合同关闭"),
    //     合同签约(13,"合同签约"),
    //     账单修改(14,"账单修改"),
    //     账单废弃(15,"账单废弃"),
    //     账单新增(16,"账单新增"),
    //     账单查询(17,"账单查询"),
    //     房源上下架(18,"房源上下架")
    { title: '图片上传', value: 1 },
    { title: '获取行政区域', value: 2 },
    { title: '小区对齐', value: 3 },
    { title: '创建门店', value: 4 },
    { title: '修改门店', value: 5 },
    { title: '创建户型', value: 6 },
    { title: '修改户型', value: 7},
    { title: '删除户型', value: 8 },
    { title: '创建房间', value: 9},
    { title: '修改房间', value: 10},
    { title: '删除房间', value: 11},
    { title: '合同关闭', value: 12},
    { title: '合同签约', value: 13},
    { title: '账单修改', value: 14},
    { title: '账单废弃', value: 15},
    { title: '账单新增', value: 16},
    { title: '账单查询', value: 17 },
    { title: '房源上下架', value: 18 },

]


//流水表枚举
export const liuShuiMeiJu = [
    { title: '待审核', value: 1,color:'gray' },
    { title: '未到帐', value: 2,color:'red' },
    { title: '已到帐', value: 3,color:'green' },
]

// 渠道状态
export const channelStatus = [
    { title: '启用', value: 1, color: 'green' },
    { title: '停用', value: 2, color: 'red' },
]

// 接口类型
export const apiType = [
    { title: '租客二要素认证', value: 1 },
    { title: '租客人脸认证', value: 2 },
    { title: '商户认证', value: 3 },
]

// 分数类型
export const scoreType = [
  { title: '全部', value: 0 },
  { title: '90分以上', value: 1 },
  { title: '80分以上90分以下', value: 2 },
  { title: '60分以上80分以下', value: 3 },
  { title: '40分以上60分以下', value: 4 },
  { title: '40分以下', value: 5 },
]

// 房源类型
export const roomTypeMap = [
  { title: '公寓运营', value: 1 },
  { title: '业主房源', value: 2 }
]

// 装修类型
export const decorateTypeMap = [
  { title: '精装修', value: 1 },
  { title: '普装修', value: 2 },
]


// 户型的窗户类型
export const houseWindowTypeMap = [
    {title: '无', value: 0},
    {title: '内窗', value: 1},
    {title: '外窗', value: 2},
    {title: '未知', value: -1},
]
export const houseTypeLabelMap = [
    {"title":"近地铁", "value":"近地铁"},
    {"title":"独卫", "value":"独卫"},
    {"title":"押一付一", "value":"押一付一"},
    {"title":"拎包入住", "value":"拎包入住"},
    {"title":"随时看房", "value":"随时看房"},
    {"title":"独立阳台", "value":"独立阳台"},
    {"title":"配套齐全", "value":"配套齐全"},
    {"title":"精装修", "value":"精装修"},
    {"title":"南北通", "value":"南北通"}
]

export const roleHouseStatusMap = [
    {"title":"待租", "value":1},
    {"title":"已租", "value":2},
    {"title":"装修中", "value":3},
    {"title":"停用", "value":4}
]

export const attachTitleTypeMap = [
    { title: '卧室', value: '卧室' },
    { title: '客厅', value: '客厅' },
    { title: '卫生间', value: '卫生间' },
    { title: '厨房', value: '厨房' },
    { title: '阳台', value: '阳台' },
    { title: '户型', value: '户型' },
]

export const deviceAttachTitleTypeMap = [
    { title: '卧室1', value: '卧室1' },
    { title: '卧室2', value: '卧室2' },
    { title: '卧室3', value: '卧室3' },
    { title: '客厅1', value: '客厅1' },
    { title: '客厅2', value: '客厅2' },
    { title: '客厅3', value: '客厅3' },
    { title: '卫生间', value: '卫生间' },
    { title: '厨房', value: '厨房' },
    { title: '阳台', value: '阳台' }
]


export const mapAccountingRecordStatus = [
    { title: '待发送', value: 1 },
    { title: '未确定', value: 2 },
    { title: '已确定', value: 3 },
    { title: '已作废', value: 4 },
    { title: '已驳回', value: 5 },
    { title: '已撤回', value: 6 },
    { title: '确认中', value: 7 },
]
export const mapAccountingRecordDataRange = [
    { title: '全部楼栋数据', value: 1 },
    { title: '指定楼栋', value: 2 },
]
/**
 * 平台对账类型
 */
export const mapPlatformreconciliationType = [
    { title: '全部', value: '' },
    { title: '系统对账', value: 1 },
    { title: '人工对账', value: 2 },
]

/**
 * 平台对账状态
 */
 export const mapPlatformreconciliationStatus = [
    { title: '全部', value: '' },
    { title: '未对账', value: 1 },
    { title: '已对账', value: 2 },
    // { title: '对账异常', value: 3 },
]

/**
 * 平台对账流水来源类别
 */
 export const mapPlatformreconciliationSourceType = [
    { title: '支付订单', value: 1 },
    { title: '系统结转', value: 2 },
    { title: '人工录入转帐', value: 3 },
]
/**
 * 平台对账同步类别
 */
export const mapPlatformReconciliationSyncType = [
    { title: '银联对账单', value: 1 },
    { title: '银联分账系统对账单', value: 2 },
    { title: '数币对账单', value: 3 },
    { title: '惠市宝对账单', value: 4 },
]

/**
 * 平台对账交易类别
 */
export const mapTradeType = [
    { title: '消费', value: 'S22',},
    { title: '退货', value: 'S30',},
    { title: '交易撤销', value: 'V52',},
]

/**
 * 租金宝同步锁数据 详情查询类型
 */
export const mapZJBSyncDataDetailType = [
    { title: '新增', value: 1 },
    { title: '修改', value: 2 },
    { title: '删除', value: 3 },
]

/**
 * 商家证件类型
 */
export const mapMerchantCardType = [
    { title: '组织机构代码证', value: '01' },
    { title: '营业执照', value: '02' },
    { title: '其他', value: '03' },
    { title: '统一社会信用证代码', value: '04' },
]

/**
 * 收款状态代码
 */
export const mapRcnclRsltStcd = [
    { title: '初始', value: '00' },
    { title: '对平', value: '01' },
    { title: '交易金额不一致', value: '03' },
    { title: '统一社会信用平台多证代码', value: '04' },
    { title: '收单多', value: '05' },
]

/**
 * 订单类型代码
 */
export const mapOrdrTpcd = [
    { title: '支付', value: "1" },
    { title: '退款', value: "2" },
]


// WEBPACK FOOTER //
// ./src/axios/dictionaries.js